import React from 'react';
import { Check, X } from 'lucide-react';
export function ForWho() {
  const forYou = ['Tenés hijos de 3 a 10 años que rechazan comidas', 'Querés dejar de cocinar doble todos los días', 'Buscás un sistema simple, no recetas sueltas', 'Preferís ingredientes comunes y accesibles', 'Querés que la cena deje de ser una batalla'];
  const notForYou = ['Buscás un plan clínico para alergias severas', 'Querés recetas gourmet o ingredientes difíciles', 'Esperás resultados mágicos de un día para otro', 'Preferís improvisar cada noche', 'Buscás convencer con discursos o premios'];
  return <section className="py-16 md:py-24 px-4 bg-[#F6EEDC]" data-id="element-116">
      <div className="max-w-5xl mx-auto" data-id="element-117">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#2E2E2E]" data-id="element-118">
          Para quién es y para quién no
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-119">
          {/* For You */}
          <div className="bg-[#FDFBF9] p-6 md:p-8 rounded-xl border-t-4 border-[#0D3B66]" data-id="element-120">
            <h3 className="text-xl font-bold text-[#2E2E2E] mb-6 flex items-center" data-id="element-121">
              <span className="w-8 h-8 bg-[#0D3B66] text-white rounded-full flex items-center justify-center mr-3" data-id="element-122">
                <Check className="w-5 h-5" data-id="element-123" />
              </span>
              Es para vos si
            </h3>
            <ul className="space-y-4" data-id="element-124">
              {forYou.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-125">
                  <Check className="w-5 h-5 text-[#0D3B66] mr-3 mt-0.5 flex-shrink-0" data-id="element-126" />
                  <span className="text-[#2E2E2E]/80" data-id="element-127">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-[#FDFBF9] p-6 md:p-8 rounded-xl border-t-4 border-[#B0AFAF]" data-id="element-128">
            <h3 className="text-xl font-bold text-[#2E2E2E] mb-6 flex items-center" data-id="element-129">
              <span className="w-8 h-8 bg-[#B0AFAF] text-white rounded-full flex items-center justify-center mr-3" data-id="element-130">
                <X className="w-5 h-5" data-id="element-131" />
              </span>
              No es para vos si
            </h3>
            <ul className="space-y-4" data-id="element-132">
              {notForYou.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-133">
                  <X className="w-5 h-5 text-[#B0AFAF] mr-3 mt-0.5 flex-shrink-0" data-id="element-134" />
                  <span className="text-[#2E2E2E]/60" data-id="element-135">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}